import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import 'src/utils/sentry';
import store from 'src/store';
import i18n from './locales';
import { getLang } from 'src/utils/lang';
import { sInit } from 'src/utils/sensor';
import { isRealProd } from 'src/config/env';
const container = document.getElementById('root') as HTMLElement;
createRoot(container).render(
	<Router>
		<Provider store={store}>
			<App />
		</Provider>
	</Router>,
);
sInit();
i18n.changeLanguage(getLang());
if (!isRealProd) {
	import('eruda').then((module) => {
		module.default.init();
	});
}
